import React from 'react';
import cx from 'classnames';
import { useDrag, useDrop } from 'react-dnd';
import { Checkbox } from 'antd';
import Button from '../../../../../components/Button';

const SubCategoryItem = ({
  subCategory,
  order,
  index,
  onSelectExhibit,
  onDelete,
  selectedExhibitCategoryIdList,
  onDragEnd,
  type,
}) => {
  const [{ isDraggingSub }, dragSub] = useDrag(
    () => ({
      type: 'SUB_CATEGORY_ITEM',
      item: { id: subCategory.id, type: 'SUB', order: `${order}-${index + 1}`, index: index },
      collect: (monitor) => ({
        isDraggingSub: monitor.isDragging(),
      }),
    }),
    [index],
  );

  const [, dropSubRef] = useDrop({
    accept: 'SUB_CATEGORY_ITEM',
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDragEnd({
          type,
          source: {
            index: item.index,
          },
          destination: {
            index: Number(index),
          },
        });
      }
    },
  });

  return (
    <tr ref={dropSubRef}>
      <td ref={dragSub} key={subCategory.id} className={cx({ 'is-dragging': isDraggingSub })}>
        <div>
          <Checkbox
            checked={selectedExhibitCategoryIdList.includes(subCategory.id)}
            onChange={(e) => onSelectExhibit(subCategory, e.target.checked)}
          />
        </div>
        <div>{`${order}-${index + 1}`}</div>
        <div>{`${subCategory.name}(${subCategory.productCount})`}</div>
        <div>
          <Button isRadius color="primary" text="삭제" onClick={() => onDelete(subCategory)}>
            삭제
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default SubCategoryItem;
